import {

  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,

  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,

  ALL_PRODUCTS_REQUEST,
  ALL_PRODUCTS_SUCCESS,
  ALL_PRODUCTS_FAIL,

  SINGLE_PRODUCT_REQUEST,
  SINGLE_PRODUCT_SUCCESS,
  SINGLE_PRODUCT_FAIL,


  MULTI_PRODUCT_UPDATE_REQUEST,
  MULTI_PRODUCT_UPDATE_SUCCESS,
  MULTI_PRODUCT_UPDATE_FAIL,

  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,

} from "../constants/productConstants";
import api from "../../api";



export const createProductAction = (product) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PRODUCT_REQUEST });

    const { data } = await api.post("/api/v1/product/create", product);

    dispatch({
      type: CREATE_PRODUCT_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: CREATE_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
export const updateProductAction = (id, product) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PRODUCT_REQUEST });

    const { data } = await api.put(`/api/v1/product/update?product_id=${id}`, product);
    

    dispatch({
      type: UPDATE_PRODUCT_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: UPDATE_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};




export const allProductsAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: ALL_PRODUCTS_REQUEST })

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/all-products?${queryString}` : `/api/v1/all-products`;

    const { data } = await api.get(url);
    dispatch({
      type: ALL_PRODUCTS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ALL_PRODUCTS_FAIL,
      payload: error.response.data.message,
    })
  }
}





export const singleProductAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: SINGLE_PRODUCT_REQUEST });

    const { data } = await api.get(`/api/v1/single-products?id=${id}`);

    dispatch({
      type: SINGLE_PRODUCT_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: SINGLE_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};



export const multiProductUpdateAction = (productData) => async (dispatch) => {
  try {
    dispatch({ type: MULTI_PRODUCT_UPDATE_REQUEST });

    const { data } = await api.put("/api/v1/multi-update-product-status", productData);

    dispatch({
      type: MULTI_PRODUCT_UPDATE_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: MULTI_PRODUCT_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

export const deleteProductAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PRODUCT_REQUEST });

    const { data } = await api.delete(`/api/v1/delete-product?id=${id}`);

    dispatch({
      type: DELETE_PRODUCT_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: DELETE_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
